module.exports = "/assets/career/team/oktawiusz_jacukowicz.png?MbAJM+D";